function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.799384 38.977C0.00583887 40.3102 0.966515 42 2.51797 42H45.482C47.0335 42 47.9942 40.3102 47.2006 38.977L25.7186 2.88722C24.9432 1.58451 23.0568 1.58451 22.2814 2.88722L0.799384 38.977Z",
  fill: "#F2C94C"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.624 31.44C29.624 29.712 28.616 27.96 26.84 27.36C28.208 26.784 29.288 25.152 29.288 23.592C29.288 22.152 28.784 21.096 27.944 20.328C27.056 19.488 25.712 18.984 24.32 18.984C22.88 18.984 21.608 19.416 20.672 20.184C19.688 21 19.088 22.2 19.064 23.856H21.152C21.176 22.848 21.512 22.032 22.16 21.504C22.664 21.096 23.36 20.832 24.272 20.832C25.184 20.832 25.928 21.192 26.384 21.648C26.912 22.152 27.176 22.824 27.176 23.592C27.176 25.344 25.952 26.4 24.032 26.4H22.952V28.296H24.032C26.072 28.296 27.536 29.352 27.536 31.392C27.536 32.304 27.2 33 26.744 33.504C26.168 34.152 25.256 34.464 24.248 34.464C23.192 34.464 22.4 34.08 21.896 33.528C21.344 32.952 21.08 32.16 21.032 31.224H18.944C18.968 32.76 19.496 33.936 20.36 34.8C21.296 35.736 22.64 36.312 24.248 36.312C26.12 36.312 27.464 35.736 28.352 34.8C29.168 33.936 29.624 32.736 29.624 31.44Z",
  fill: "white"
});

var Svg3Low = function Svg3Low(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg3Low, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3-low.6fea455b.svg";
export { ForwardRef as ReactComponent };